import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import thumbnailsWithBlurSchema from '@utils/validate/blocksSchemes/thumbnailsWithBlurSchema';
import linkSchema from '@utils/validate/blocksSchemes/linkSchema';
const slidesWithTextSchema = Joi.object({
  type: Joi.string().valid('slidesWithText').required(),
  code: Joi.string().allow('', null).required(),
  slides: Joi.array().items(Joi.object({
    itemId: Joi.string().required(),
    type: Joi.string().allow('', null).required(),
    link: linkSchema.allow('', null).required(),
    buttonText: Joi.string().allow('', null).required(),
    buttonPosition: Joi.string().allow('', null).required(),
    buttonStyle: Joi.string().allow('', null),
    content: Joi.object({
      topText: Joi.string().allow('', null).required(),
      topTextColor: Joi.string().allow('', null).required(),
      title: Joi.string().allow('', null).required(),
      titleColor: Joi.string().allow('', null).required(),
      description: Joi.string().allow('', null).required(),
      descriptionColor: Joi.string().allow('', null).required(),
      vertical: Joi.string().allow('', null).required(),
      horizontal: Joi.string().allow('', null).required()
    }).required(),
    video: mediaUrlSchema.allow(null),
    image: mediaUrlSchema.allow(null),
    blur: mediaUrlSchema.allow(null),
    thumbnailWithBlur: thumbnailsWithBlurSchema.allow(null)
  }).unknown(true))
});
export default slidesWithTextSchema;